import React from "react";

function TextInputComponent({
  label,
  inputPlaceHolder,
  inputValue,
  onChangeValue,
  inputError,
  inputType,
}) {
  return (
    <div className="mx-2 mt-3">
      <h2 className="block text-left">{label}</h2>
      <input
        className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${
          inputError && "border-red-600 focus:outline-red-600 bg-red-100"
        }`}
        placeholder={inputPlaceHolder}
        value={inputValue}
        onChange={(e) => onChangeValue(e.target.value)}
        type={inputType}
      />
      <h2 className="text-xs text-left text-[#ff0000]">{inputError}</h2>
    </div>
  );
}

export default TextInputComponent;
